import { useEffect, useRef, useState } from 'react';
import { ArrowUp, Loader2 } from 'lucide-react';

interface Props {
  disabled: boolean;
  busy: boolean;
  error?: string | null;
  onSend: (text: string) => void;
}

/** Campo di scrittura che cresce con il testo: Invio manda, Maiusc+Invio va a capo. */
export function AiHelpComposer({ disabled, busy, error, onSend }: Props) {
  const [value, setValue] = useState('');
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => { ref.current?.focus(); }, []);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 160)}px`;
  }, [value]);

  const send = () => {
    const text = value.trim();
    if (!text || disabled) return;
    setValue('');
    onSend(text);
  };

  return (
    <div className="px-3 pb-3 pt-2 bg-white dark:bg-gray-900">
      {error && <p className="text-[11px] text-amber-700 mb-1.5 px-1">{error}</p>}
      <div className="flex items-end gap-2 rounded-xl border border-[rgba(55,53,47,0.16)] dark:border-gray-700 bg-white dark:bg-gray-800 px-3 py-2 focus-within:border-[#37352F] dark:focus-within:border-gray-400 transition-colors">
        <textarea
          ref={ref}
          rows={1}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); } }}
          placeholder="Chiedi qualcosa su Flusia…"
          aria-label="Scrivi all'assistente"
          disabled={disabled}
          className="flex-1 min-w-0 resize-none bg-transparent border-0 p-0 text-[13.5px] leading-6 text-[#37352F] dark:text-gray-100 placeholder:text-[#9B9A97] focus:outline-none focus:ring-0 disabled:opacity-50"
        />
        <button type="button" onClick={send} disabled={!value.trim() || disabled} aria-label="Invia"
          className="w-7 h-7 flex-shrink-0 rounded-full bg-[#37352F] text-white flex items-center justify-center disabled:bg-[#E9E9E7] disabled:text-[#9B9A97] transition-colors">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ArrowUp className="w-3.5 h-3.5" />}
        </button>
      </div>
      <p className="mt-1.5 px-1 text-[11px] text-[#9B9A97]">Invio per mandare · Maiusc+Invio per andare a capo</p>
    </div>
  );
}
